<template>
  <div class="cancellation-success">
    <div class="cancellation-success__top">
      <button
        @click="$emit('close-cancel-subscription-modal')"
        class="cancellation-success__close"
      >
        <span class="cancellation-success__close--icon material-icons"
          >clear</span
        >
      </button>
      <CheckmarkIcon class="cancellation-success__checkmark" />
    </div>
    <div class="cancellation-success__bottom">
      <h6 class="cancellation-success__title">Thank you for your feedback</h6>
      <p class="cancellation-success__copy">
        Your subscription has been cancelled.<br />
        You will have access to your account until {{ planExpiryDate }}.
      </p>
      <div class="cancellation-success__btn-wrapper">
        <button
          @click="$emit('close-cancel-subscription-modal')"
          class="cancellation-success__cancel-btn btn__action"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CheckmarkIcon from '@/assets/icons/subscriptions/cancel-sub/checkmark.svg'

export default {
  name: 'Success',
  components: {
    CheckmarkIcon: { ...CheckmarkIcon, name: 'CheckmarkIcon' },
  },
  props: {
    planExpiryDate: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.cancellation-success {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: 0;
  margin: 0 auto;
  background-color: var(--white);
  color: var(--white);
  width: 100%;
  height: 100%;
  overflow: scroll;
  @include tablet {
    border-radius: 25px;
    top: 7%;
    max-width: 450px;
    min-height: 300px;
    height: auto;
  }
  @include desktop {
    overflow: hidden;
  }
  @media screen and (max-height: 800px) {
    overflow: scroll;
    height: 100%;
    width: 100%;
  }
  &__top {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    height: 150px;
    width: 100%;
  }
  &__close {
    width: 50px;
    height: 50px;
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 5px;
    z-index: 2;
    &--icon {
      color: var(--black);
    }
  }
  &__checkmark {
    width: 100%;
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
  }
  &__bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    color: var(--black);
    @include tablet {
      padding: 50px 25px;
    }
  }
  &__title {
    margin: 50px 0 25px 0;
    max-width: 250px;
    font-family: var(--font-bold);
    font-size: rem(34px);
  }
  &__copy {
    font-size: rem(21px);
    text-align: center;
    padding: 0 25px;
    width: 100%;
  }
  &__btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__cancel-btn {
    color: var(--black);
    border: 3px solid var(--orange);
    margin: 25px 0 0 0;
    padding: 10px 25px;
    font-weight: 700;
    justify-content: center;
    &:hover {
      color: var(--white);
    }
  }
}
</style>
